import { type FormikErrors, type FormikTouched, type FormikValues } from "formik"
import _ from "lodash"

export function isFormFieldInValid<T extends string, Values extends FormikValues = FormikValues>(
  name: T,
  formik: { touched?: FormikTouched<Values>; errors?: FormikErrors<Values> },
) {
  const touchedValue = _.get(formik.touched, name)
  const errorValue = _.get(formik.errors, name)
  return !!(touchedValue && errorValue)
}

export function getFormErrorMessage<T extends string, Values extends FormikValues = FormikValues>(
  name: T,
  formik: { touched?: FormikTouched<Values>; errors?: FormikErrors<Values> },
  options?: {
    errorMessage?: string
    showAlways?: boolean
  },
) {
  const error = options?.errorMessage ?? _.get(formik.errors, name)

  return isFormFieldInValid(name, formik) || (options?.showAlways && !!error) ? (
    typeof error === "object" ? (
      <ul className="">
        {Object.values(error)
          .filter(Boolean)
          .map((err, idx) =>
            typeof err === "string" ? (
              <li key={idx} className="label-small text-textError">
                {err}
              </li>
            ) : Array.isArray(err) ? (
              err.map((e, i) => (typeof e === "string" ? <li key={`${idx}-${i}`}>{e}</li> : null))
            ) : null,
          )}
      </ul>
    ) : (
      <p className="label-small text-textError">{error}</p>
    )
  ) : undefined
}
